import React from 'react'

import './stepper.scss';

function Stepper(props) {
	return(
		<div className="stepper stepper--size-meduim stepper--weight-light">
			<span className="stepper--weight-bold">{props.currentStep}</span> / {props.totalSteps}
		</div>
	);
}

export default Stepper